"use client";
import Hotline from "@/app/(pages)/(dashboard)/profile/support/hotlineSupportModal";
import {
  UniversalStorageConstants,
  UniversalStorageUtils,
  useAppContext,
} from "@thriwe-2-0/thriwe-ui-utils";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useClientConfigProvider } from "../../config/client-config-provider";
import Constants from "../../constants/constants";

export default function Footer2() {
  const router = useRouter();
  const pathname = usePathname();
  const { t } = useTranslation();

  const { config, getImagePath } = useClientConfigProvider();
  const context = useAppContext();
  const [isLogin, setIsLogin] = useState<boolean>(true);
  const [showHotlineModal, setShowHotlineModal] = useState(false);

  const {
    state: { isMobile },
  } = context;
  const pathName = usePathname();

  useEffect(() => {
    const auth = !!UniversalStorageUtils.getItem(
      config?.nativeDataSavingType,
      UniversalStorageConstants.AUTH_TOKEN
    );

    setIsLogin(auth);
  }, []);

  const getFooterClass = () => {
    return Constants.delayBookingRoutes.includes(pathname)
      ? "footer-background-delay"
      : "footer-background-normal";
  };

  const getFooterClassBottomMargin = () => {
    return Constants.footerMarginRoutes.includes(pathname)
      ? "footer-margin-v2"
      : "";
  };

  if (pathName == "/airport-transfer" && isMobile) return <></>;
  return (
    <div className={`custom_footer_container ${getFooterClass()}`}>
      {
        <Hotline
          showHotlineModal={showHotlineModal}
          setShowHotlineModal={setShowHotlineModal}
        />
      }
      <>
        {" "}
        {Boolean(config?.footer.footerLink2?.length) && (
          <div className="custom_footer_section">
            <div className="custom_footer_link_container">
              <ul className="custom_footer_link">
                {config?.footer.footerLink2?.map((link, index) => {
                  return (
                    <li
                      style={{
                        color:
                          pathname == link?.routeLink
                            ? "var(--LightTheme-Primary) !important"
                            : "",
                      }}
                      onClick={() => {
                        if (link.routeLink == "") {
                          setShowHotlineModal(true);
                          return;
                        }
                        router.push(link?.routeLink);
                      }}
                      key={index}
                    >
                      {t("footer." + link?.name, link?.name)}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
        <div
          className={`custom_footer_copyright_text  ${getFooterClassBottomMargin()}`}
        >
          {t("footer.copyRightTextInFooter")}
          {config?.footer.poweredByThriwe && (
            <div className="custom_footer_poweredByThriwe">
              <div>
                {t("footer.Powered by")}
                <span></span>{" "}
                <Image
                  src={getImagePath("thriwe-logo.png")}
                  alt=""
                  width={84}
                  height={26}
                />
              </div>
            </div>
          )}
          <div className="custom_footer_right"></div>
        </div>{" "}
      </>
    </div>
  );
}
